
import { Theme } from '@mui/material/styles';

import { withStyles } from 'tss-react/mui';

interface IProps {
  classes?: any;
}

const styles = (theme: Theme) => ({
  container: {
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    padding: '30px 16px',
    boxSizing: 'border-box',
    [theme.breakpoints.down('sm')]: {
      padding: '4px !important',
    },
  },
});

/**
 * Grid med inställningar för att visas över hel skärmen, används av startpanelen
 */
const MainGrid: React.FunctionComponent<
  React.PropsWithChildren<IProps>
> = props => <div className={props.classes.container}>{props.children}</div>;

export default withStyles(MainGrid, styles);
